import { render, staticRenderFns, recyclableRender, components } from "./PreviewVideo.vue?vue&type=template&id=4ae7068a&scoped=true&"
var renderjs
import script from "./PreviewVideo.vue?vue&type=script&lang=js&"
export * from "./PreviewVideo.vue?vue&type=script&lang=js&"
import style0 from "./PreviewVideo.vue?vue&type=style&index=0&id=4ae7068a&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@dcloudio/vue-cli-plugin-uni/packages/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ae7068a",
  null,
  false,
  components,
  renderjs
)

export default component.exports